import { IContentViewModelProperty, IContentViewProperty } from '~/interfaces/contentViewInterfaces'
import { InputFormatType } from '../../../../formability/form_builder/models/inputFormatType'
import CharacterCount from '../../../../formability/form_builder/models/characterCounts/characterCount'
import { DatetimeMode } from '~/models/datetimeMode'

/**
 * Serves as a common interface for anything chosen as the "property" of a ModelProperty content element
 */
export default abstract class ContentViewModelProperty implements IContentViewModelProperty {
  canHaveCharacterCount: boolean
  canHaveFormat: boolean
  charLimit: string
  datetimeMode: DatetimeMode
  format: string
  hasMinOrMaxLength: boolean
  isDateTime: boolean
  isMappedProperty: boolean
  name: string

  protected constructor(public property: IContentViewProperty) {

  }

  get is_required(): boolean {
    return this.property.is_required
  }

  get label_title(): string {
    return this.property.label_title
  }

  get hasLabelTitle(): boolean {
    return this.property.label_title !== null && this.property.label_title.length > 0
  }

  get canBeRequired(): boolean {
    return this.property.canBeRequired
  }

  get icon(): string {
    return this.property.icon
  }

  get isIndexable(): boolean {
    return this.property.isIndexable
  }

  get isIndexed(): boolean {
    return this.property.isIndexed
  }
}